import React from 'react'
import { Chip } from '@mui/material'
import { Order } from '../../../interfaces/Order/Order'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import { Courier } from '../../../interfaces/Courier/Courier'
import { ORDER_STATE_LABELS, ORDER_STATE_COLORS } from '../types'
import { TypeOrder } from '../../../interfaces/Order/TypeOrder'

interface GetColumnsConfigParams {
  couriers?: Courier[]
  typeOrders? : TypeOrder[]
}

export const getColumnsConfig = ({
  couriers,
  typeOrders
}: GetColumnsConfigParams = {}): TableColumn<Order>[] => [
  {
    key: 'referenceId',
    title: 'ID de Pedido',
    sortable: true
  },
  {
    key: 'orderStateId',
    title: 'Estado',
    sortable: true,
    render: (value) => {
      const stateId = value as keyof typeof ORDER_STATE_LABELS
      const label = ORDER_STATE_LABELS[stateId] || 'Desconocido'
      const color = ORDER_STATE_COLORS[stateId] || 'default'
      return (
        <Chip
          label={label}
          style={color}
          size="small"
        />
      )
    }
  },
  {
    key: 'courierDeliveryDate',
    title: 'Fecha Entrega',
    sortable: true,
    render: (value) =>
      value ? new Date(value as string).toLocaleDateString() : ''
  },
  {
    key: 'courierId',
    title: 'Courier',
    sortable: true,
    render: (value) => {
      const courier = couriers?.find(c => c.courierId === value)
      return courier ? courier.name : value?.toString() || ''
    }
  },
  {
    key: 'courierServiceId',
    title: 'Servicio',
    sortable: true,
    render: (value) => {
      const allServices = couriers?.flatMap(c => c.courierServices) || []
      const service = allServices.find(cs => cs.courierServiceId === value)
      return service ? service.name : value?.toString() || ''
    }
  },
  {
    key: 'typeOrderId',
    title: 'Tipo',
    sortable: true,
    render: (value) => {
      const typeOrder = typeOrders?.find(t => t.typeOrderId === value)
      return typeOrder ? typeOrder.description : value?.toString() || ''
    }
  }  
]
